import React, { useState } from "react";
import { useStyles } from "./ApplicantSection.styles";
import {
  PhoneIcon,
  EmailIcon,
  PlaceIcon,
  PersonIcon,
  PermContactCalendarIcon,
  AttachMoneyIcon,
  DirectionsCar,
  InsertDriveFileIcon,
  GetAppIcon,
  AddIcon,
  BusinessIcon,
  AutorenewIcon,
  EditIcon,
} from "../../../components/icons";
import CoverageIcon from "../../../assets/img/life/CoverageIcon";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Link,
  Typography,
  Modal,
  TextField,
} from "@mui/material";
import { defaultTheme, useMobile } from "../../../themes";
import { formatCurrency, replaceWhiteSpaceWithPlus } from "../../../utils";
import { formatPhone, generateUrl } from "../../../lib";
import {
  adminActions,
  authSelectors,
  useDispatch,
  useSelector,
} from "../../../state";
import { QuoteDocument } from "../../../state/admin/state";
import { useParams, Link as WebLink } from "react-router-dom";
import MainPages from "../../main";

export const ApplicantInfo = ({
  applicant,
  baseInfo,
  quoteType,
  aff_agent,
  agency,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const birthDay = `${baseInfo?.Birthdate?.month}/${baseInfo?.Birthdate?.day}/${baseInfo?.Birthdate?.year}`;
  const { addr1, city, state, zip, drivers } = applicant;
  const primaryApplicant = drivers?.find(
    (d) => d.relationship_to_applicant === "I",
  );
  const secondaryApplicant = drivers?.find(
    (d) => d.relationship_to_applicant !== "I",
  );
  const leasingUrl = generateUrl(`https://${agency.domain}${MainPages.autoLeasingPage.path}`, {
    query: {
      firstName: applicant.first_name,
      lastName: applicant.last_name,
      email: applicant.email,
      phone: applicant.phone,
      addr1,
      city,
      state,
      zip,
      dob: primaryApplicant?.dob || "",
      coAppFirstName: secondaryApplicant?.first_name || "",
      coAppLastName: secondaryApplicant?.last_name || "",
      coAppDob: secondaryApplicant?.dob || "",
    },
  });
  return (
    <Box className={classes.topSection}>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography className={classes.header}>
            Applicant information
          </Typography>
          <IconButton
            sx={{ height: "25px", width: "25px" }}
            onClick={() => setOpenModal(true)}
          >
            <EditIcon />
          </IconButton>
          {openModal && (
            <EditApplicantModal
              open={openModal}
              setOpen={setOpenModal}
              applicant={applicant}
            />
          )}
        </Box>
        <Box className={classes.contactWrapper}>
          {applicant.email && (
            <Box className={classes.contactItem}>
              <EmailIcon />
              <Link href={`mailto:${applicant.email}`}>
                {" "}
                <Typography className={classes.contactTxt}>
                  {applicant.email}
                </Typography>
              </Link>
            </Box>
          )}
          {applicant.phone && (
            <Box className={classes.contactItem}>
              <PhoneIcon />

              <Link href={`tel:${applicant.phone}`}>
                <Typography className={classes.contactTxt}>
                  {formatPhone(applicant.phone)}
                </Typography>
              </Link>
            </Box>
          )}
          {applicant.addr1 && (
            <Box>
              <Box className={classes.contactItem}>
                <PlaceIcon />
                <Typography className={classes.contactTxt}>
                  {applicant.addr1}
                  <br /> {applicant.city}
                  {", "} {applicant.state} {applicant.zip}
                </Typography>
              </Box>
              {quoteType === "Home" || quoteType === "Bundle" ? (
                <Box sx={{ margin: "-15px 0 8px 34px" }}>
                  <WebLink
                    style={{ fontSize: 14 }}
                    target="_blank"
                    to={{
                      pathname: replaceWhiteSpaceWithPlus(
                        `https://www.google.com/maps/place/${addr1}+${city}+${state}+${zip}/`,
                      ),
                    }}
                  >
                    Map
                  </WebLink>
                  <WebLink
                    style={{ fontSize: 14, margin: "0 10px" }}
                    target="_blank"
                    to={{
                      pathname: replaceWhiteSpaceWithPlus(
                        `https://www.zillow.com/homes/${addr1}+${city}+${state}+${zip}/`,
                      ),
                    }}
                  >
                    Zillow
                  </WebLink>
                </Box>
              ) : null}
            </Box>
          )}
          {!!baseInfo && (
            <Box className={classes.contactItem}>
              <PermContactCalendarIcon />
              <div className={classes.contactTxt}>
                <Typography>{baseInfo?.Birthdate.ActualAge} years</Typography>
                <div className={classes.birthDate}>{birthDay}</div>
              </div>
            </Box>
          )}
          {applicant.previousAddress?.street_line ? (
            <Box>
              {" "}
              <Divider />
              <Typography
                sx={{
                  margin: "10px 0 6px 34px",
                  fontSize: "14px",
                  fontWeight: 500,
                }}
              >
                Previous address
              </Typography>
              <Box className={classes.contactItem}>
                <PlaceIcon />
                <Typography
                  className={classes.contactTxt}
                  sx={{ marginBottom: 0 }}
                >
                  {applicant.previousAddress.street_line}
                  <br /> {applicant.previousAddress.city}
                  {", "} {applicant.previousAddress.state}{" "}
                  {applicant.previousAddress.zip}
                </Typography>
              </Box>
            </Box>
          ) : null}
          {agency?.name ? (
            <Box className={classes.contactItem}>
              <BusinessIcon />
              <Typography className={classes.contactTxt}>
                {agency.name}
              </Typography>
            </Box>
          ) : null}
          {aff_agent?.affiliate_agent.first_name ? (
            <Box className={classes.contactItem}>
              <AutorenewIcon />
              <Typography
                sx={{ fontWeight: 500 }}
                className={classes.contactTxt}
              >
                {aff_agent.affiliate_agent.first_name +
                  " " +
                  aff_agent.affiliate_agent.last_name}
              </Typography>
            </Box>
          ) : (
            <Box>
              {" "}
              <Button
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  letterSpacing: 1,
                }}
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => {
                  dispatch(adminActions.setAssignReferrerOpen(true));
                }}
              >
                Add referrer
              </Button>
            </Box>
          )}
          {quoteType === "Auto" || quoteType === "Bundle" ? (
            <Box>
              <Button
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                }}
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => {
                  window.open(leasingUrl, "_blank");
                }}
              >
                Leasing Application
              </Button>
            </Box>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export const SupportingDocs = ({ quoteDocuments }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  return (
    <Box className={classes.topSection}>
      <Box>
        <Typography className={classes.header}>Supporting documents</Typography>
        {quoteDocuments?.length ? (
          <Box className={classes.contactWrapper}>
            {quoteDocuments.map((doc: QuoteDocument) => (
              <Box className={classes.docs} key={doc.file_path}>
                <Box className={classes.contactItem}>
                  <InsertDriveFileIcon />
                  <Typography className={classes.contactTxt}>
                    {doc.filename}
                  </Typography>
                </Box>
                <span
                  className={classes.downloadBtn}
                  onClick={() => dispatch(adminActions.download(doc.file_path))}
                >
                  <GetAppIcon />
                </span>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography className={classes.emptyState}>
            There are no documents yet
          </Typography>
        )}
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => dispatch(adminActions.setUploadModalOpen(true))}
        >
          Upload document
        </Button>
      </Box>
    </Box>
  );
};

export const LifeCoverage = ({ baseInfo }) => {
  const classes = useStyles();
  return (
    <Box className={classes.topSection}>
      <Box className={classes.contactWrapper}>
        <Typography className={classes.coverage}>Coverage</Typography>

        {baseInfo?.title && (
          <Box className={classes.contactItem}>
            <CoverageIcon color={defaultTheme.palette.primary.main} />
            <Typography className={classes.titleTxt}>
              {baseInfo?.title}
            </Typography>
          </Box>
        )}
        {baseInfo?.FaceAmount && (
          <Box className={classes.contactItem}>
            <AttachMoneyIcon />
            <Typography className={classes.contactTxt}>
              {formatCurrency(baseInfo?.FaceAmount)}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export const VehiclesList = ({ vehicles }) => {
  const classes = useStyles();
  const isMobile = useMobile();
  return (
    <Box className={classes.bottomSection}>
      {!isMobile && (
        <Typography className={classes.driversTitle}>Vehicles</Typography>
      )}
      {vehicles.map((vehicle, index) => {
        return (
          <div key={index} className={classes.driverCard}>
            <Grid container>
              <DirectionsCar className={classes.driverIcon} />
              <div>
                <p>
                  {vehicle.make} {vehicle.model} {vehicle.model_year}
                </p>

                <p className={classes.driverAccentText}>{vehicle.vin}</p>
              </div>
            </Grid>
          </div>
        );
      })}
    </Box>
  );
};

export const DriversList = ({ drivers, setAsPrimary }) => {
  const classes = useStyles();
  const isMobile = useMobile();
  return (
    <Box className={classes.bottomSection}>
      {!isMobile && (
        <Typography className={classes.driversTitle}>Drivers</Typography>
      )}
      {drivers.map((driver: any, index) => {
        const isPrimary = Boolean(driver["relationship_to_applicant"] === "I");
        return (
          <div key={index} className={classes.driverCard}>
            <Grid
              container
              className={!isPrimary ? "hoverable" : ""}
              onClick={() => (isPrimary ? {} : setAsPrimary(driver))}
            >
              <PersonIcon className={classes.driverIcon} />
              <div>
                <p>
                  {driver["first_name"]} {driver["last_name"]}
                </p>
                <p className={classes.driverAccentText}>{driver["dob"]}</p>
                <p className={classes.driverAccentText}>
                  DL#: {driver.manualLicense || driver["dlNumber"]}
                </p>
              </div>
              <Box className={classes.primaryContainer}>
                {isPrimary ? (
                  <p className={classes.primaryTag}>Primary</p>
                ) : (
                  <p className={classes.makePrimaryTag}>Make primary</p>
                )}
              </Box>
            </Grid>
          </div>
        );
      })}
    </Box>
  );
};

export const HomeApplicants = ({ homeApplicants, setAsPrimary }) => {
  const classes = useStyles();
  const isMobile = useMobile();
  return (
    <Box className={classes.bottomSection}>
      {!isMobile && (
        <Typography className={classes.homeTitle}>Home Applicants</Typography>
      )}
      {homeApplicants.map((applicant, index) => {
        const isPrimary = index === 0;
        return (
          <div key={index} className={classes.driverCard}>
            <Grid
              container
              className={!isPrimary ? "hoverable" : ""}
              onClick={() => (isPrimary ? {} : setAsPrimary(applicant))}
            >
              <PersonIcon className={classes.driverIcon} />
              <div>
                <p>
                  {applicant["first_name"]} {applicant["last_name"]}
                </p>
                <p className={classes.driverAccentText}>{applicant["dob"]}</p>
              </div>
              <Box className={classes.primaryContainer}>
                {isPrimary ? (
                  <p className={classes.primaryTag}>Primary</p>
                ) : (
                  <p className={classes.makePrimaryTag}>Make primary</p>
                )}
              </Box>
            </Grid>
          </div>
        );
      })}
    </Box>
  );
};

export function EditApplicantModal({ open, setOpen, applicant }) {
  const dispatch = useDispatch();
  const role = useSelector(authSelectors.activeRole);
  const activeAgencyId = useSelector(authSelectors.activeAgencyId);
  const { masterQuoteId }: any = useParams();
  const [phoneNumber, setPhoneNumber] = useState(applicant?.phone || "");
  const [email, setEmail] = useState(applicant?.email || "");
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");

  const handlePhoneChange = (e) => {
    setPhoneNumber(e.target.value);
    if (phoneError) setPhoneError("");
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (emailError) setEmailError("");
  };

  const validateInputs = () => {
    let isValid = true;
    if (!phoneNumber.trim()) {
      setPhoneError("Phone number is required");
      isValid = false;
    } else if (!/^\d{10}$/.test(phoneNumber.replace(/\D/g, ""))) {
      setPhoneError("Please enter a valid 10-digit phone number");
      isValid = false;
    }
    if (!email.trim()) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      setEmailError("Please enter a valid email address");
      isValid = false;
    }

    return isValid;
  };

  const handleSubmit = () => {
    if (validateInputs()) {
      dispatch(
        adminActions.updateQuoteContact(
          masterQuoteId,
          { phone: phoneNumber, email },
          role,
          activeAgencyId,
        ),
      );
      setOpen(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setPhoneNumber(applicant?.phone || "");
    setEmail(applicant?.email || "");
    setPhoneError("");
    setEmailError("");
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="edit-applicant-modal-title"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography
          id="edit-applicant-modal-title"
          variant="h6"
          component="h2"
          mb={2}
        >
          Edit Contact Information
        </Typography>

        <Box mb={3}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              fullWidth
              variant="outlined"
              type="tel"
              value={phoneNumber}
              onChange={handlePhoneChange}
              error={!!phoneError}
              helperText={phoneError}
              size="small"
              label="Phone Number"
            />
          </Box>
        </Box>

        <Box mb={4}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              fullWidth
              variant="outlined"
              type="email"
              value={email}
              onChange={handleEmailChange}
              error={!!emailError}
              helperText={emailError}
              size="small"
              label="Email Address"
            />
          </Box>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
